/**
 * ShellLayout — admin shell layout + navigation (ODE-P01-T10 + ODE-P07-T01 +
 * ODE-P07-T02 + ODE-P07-T03 + ODE-P07-T04 + ODE-P07-T06 + ODE-P07-T07 +
 * ODE-P07-T08).
 *
 * Sidebar navigation: the Operational Overview dashboard (ODE-P07-T01, real
 * data wiring), the Live Tracking Map (ODE-P07-T02, real data wiring), the
 * Delivery Order Search & Detail module (ODE-P07-T03, real data wiring), the
 * Admin Uang Jalan Operational View (ODE-P07-T08, real data wiring), the
 * Journey History & Stop Points module (ODE-P07-T06, real data wiring), the
 * Checkpoint Timeline module (ODE-P07-T04, real data wiring), the
 * Operational Reports & Export module (ODE-P07-T09, real data wiring), the
 * Evidence Viewer module (ODE-P07-T05, real data wiring), plus the
 * REQ-043..048 module placeholders that have no real page yet, staff identity,
 * and logout. The active entry is highlighted; the main content area renders
 * the routed page. Nav visibility is UX only — authorization is enforced
 * server-side.
 *
 * Traces to: ODE-PRD-REQ-043..048, ODE-PRD-REQ-084, ODE-PRD-REQ-090.
 */

import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';
import { MODULES } from '../rbac/catalog.js';

export function ShellLayout(): JSX.Element {
  const { session, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = (): void => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="shell">
      <aside className="sidebar" aria-label="Navigasi modul admin">
        <div className="brand">ODE Admin</div>
        <nav>
          <ul>
            <li>
              <NavLink
                to="/overview"
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                Operational Overview
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/do-search"
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                Delivery Order Search
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/uang-jalan"
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                Uang Jalan
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/checkpoint-timeline"
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                Checkpoint Timeline (per DO)
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/geofence-exceptions"
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                Geofence Exceptions
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/evidence"
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                Evidence Viewer (REQ-047)
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/map"
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                Live Tracking Map
              </NavLink>
            </li>
          </ul>
          <p className="nav-section">Modul</p>
          <ul>
            {MODULES.map((module) => (
              <li key={module.id}>
                <NavLink
                  to={module.route ?? `/modules/${module.id}`}
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                >
                  {module.title}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <div className="staff">
          <span data-testid="staff-identity">
            {session?.staff.displayName ?? session?.staff.staffId ?? ''}
          </span>
          <button type="button" data-testid="logout" onClick={onLogout}>
            Keluar
          </button>
        </div>
      </aside>
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}